import { AccountMergingDialog } from "./AccountMergingDialog";
import { useAccountMerging } from "../hooks/useAccountMerging";

const AVATAR_COLORS = ['#7239E5', '#438AE7', '#E66C2F'];
const getAvatarColor = (index: number) => AVATAR_COLORS[index % AVATAR_COLORS.length];

export function AccountMergingEntry() {
  const {
    open,
    setOpen,
    data,
    loading,
    flowStep,
    goBackToPrimary,
    proceedToSecondary,
    primaryEmail,
    setPrimaryEmail,
    secondaryActions,
    setSecondaryAction,
    transferInputs,
    setTransferInput,
    transferErrors,
    verifiedTransfers,
    otpState,
    isOtpLoading,
    isVerifyLoading,
    isResendLoading,
    otpMessage,
    sendInitialSelfOtp,
    requestOtp,
    verifyOtp,
    resendOtp,
    closeOtp,
    isSubmitting,
    isSubmitDisabled,
    submitMerging,
    isConfirmOpen,
    setIsConfirmOpen,
    handleLogout,
    resendCountdown,
  } = useAccountMerging();

  return (
    <AccountMergingDialog
      open={open}
      onOpenChange={setOpen}
      data={data}
      isLoading={loading}
      flowStep={flowStep}
      goBackToPrimary={goBackToPrimary}
      proceedToSecondary={proceedToSecondary}
      primaryEmail={primaryEmail}
      setPrimaryEmail={setPrimaryEmail}
      secondaryActions={secondaryActions}
      setSecondaryAction={setSecondaryAction}
      transferInputs={transferInputs}
      setTransferInput={setTransferInput}
      transferErrors={transferErrors}
      verifiedTransfers={verifiedTransfers}
      otpState={otpState}
      isOtpLoading={isOtpLoading}
      isVerifyLoading={isVerifyLoading}
      isResendLoading={isResendLoading}
      otpMessage={otpMessage}
      sendInitialSelfOtp={sendInitialSelfOtp}
      requestOtp={requestOtp}
      verifyOtp={verifyOtp}
      resendOtp={resendOtp}
      closeOtp={closeOtp}
      getAvatarColor={getAvatarColor}
      isSubmitting={isSubmitting}
      submitMerging={submitMerging}
      isSubmitDisabled={isSubmitDisabled}
      isConfirmOpen={isConfirmOpen}
      setIsConfirmOpen={setIsConfirmOpen}
      handleLogout={handleLogout}
      resendCountdown={resendCountdown}
    />
  );
}